import { DocumentNode, useQuery } from "@apollo/client";

export default function useContentfulQuery<Q, V>(query: DocumentNode, variables?: Omit<V, "preview">) {
    const options = { variables: { preview: process.env.NODE_ENV !== 'production', ...variables } } as unknown as V
    return useQuery<Q, V>(query, options);
}